(function () {
  function init() {
    var p = window.__shopifyProduct;
    if (!p) return;

    document.addEventListener('click', function (e) {
      // Aura/Switch Themes usa botones con data-media-id en la galería
      var thumb = e.target.closest('[data-media-id], [data-thumbnail-id]');
      if (!thumb) return;

      var mediaId =
        parseInt(thumb.dataset.mediaId || thumb.dataset.thumbnailId) || null;

      if (!mediaId) return;

      // Buscar la variante cuya imagen coincida con el thumbnail clickeado
      var match = null;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].featured_media_id === mediaId) {
          match = p.variants[i];
          break;
        }
      }

      if (!match) return;

      // Actualizar cada opción del selector
      // Aura soporta dropdown (<select>) y buttons (<input type="radio">)
      match.options.forEach(function (value, index) {
        var name = p.options[index];

        // --- Dropdown style ---
        var select = document.querySelector(
          'select[name="options[' + name + ']"]'
        );
        if (select && select.value !== value) {
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // --- Button / pill style (radio inputs) ---
        var radio = document.querySelector(
          'input[type="radio"][name="options[' + name + ']"][value="' + CSS.escape(value) + '"]'
        );
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          radio.dispatchEvent(new Event('input', { bubbles: true }));
        }

        // --- Switch/Aura también puede usar <fieldset> con buttons tipo label ---
        var labelBtn = document.querySelector(
          '[data-option-name="' + name + '"] [data-option-value="' + CSS.escape(value) + '"],' +
          'label[for*="' + CSS.escape(value) + '"]'
        );
        if (labelBtn) labelBtn.click();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
